var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M29 36c-1.4 0-2.583-.483-3.55-1.45C24.483 33.583 24 32.4 24 31s.483-2.583 1.45-3.55C26.417 26.483 27.6 26 29 26s2.583.483 3.55 1.45C33.517 28.417 34 29.6 34 31s-.483 2.583-1.45 3.55C31.583 35.517 30.4 36 29 36m-19 8c-1.1 0-2.042-.391-2.826-1.174C6.391 42.042 6 41.1 6 40V12c0-1.1.391-2.041 1.174-2.824C7.958 8.392 8.9 8 10 8h2V4h4v4h16V4h4v4h2c1.1 0 2.042.392 2.826 1.176C41.609 9.959 42 10.9 42 12v28c0 1.1-.391 2.042-1.174 2.826C40.042 43.609 39.1 44 38 44zm0-4h28V20H10zm0-24h28v-4H10zm0 0v-4z"
  }))));
};
export default SvgCalendar;